import palette from '@lib/core/src/theme/palette';
import { Box, Stack, styled, Button, Typography } from '@mui/material';
import { TextareaAutosize } from '@mui/material';

const BORDER_RADIUS = '18px';

export const ContainerEnvelope = styled(Box)({
  overflow: 'visible',
  width: '100%'
});

export const Container = styled(Stack)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  backgroundColor: palette.white,
  borderRadius: BORDER_RADIUS,
  border: 'none',
  padding: '2px 2px 12px 2px',
  zIndex: 1,
  boxShadow:
    '0 0 0 4px rgba(226,22,165,0.15), 0 2px 16px 0 rgba(246,151,122,0.10), 0 4px 32px 0 rgba(161,90,209,0.10)',
  '&:hover': {
    boxShadow:
      '0 0 0 6px rgba(226,22,165,0.18), 0 4px 24px 0 rgba(246,151,122,0.15), 0 6px 48px 0 rgba(161,90,209,0.15)'
  },
  '::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: BORDER_RADIUS,
    padding: '2px',
    background:
      'linear-gradient(107deg, #E216A5 6.17%, #F6977A 41.84%, #F0D1D5 71.81%, #A15AD1 105.11%)',
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    pointerEvents: 'none',
    zIndex: -1
  }
});

export const HeaderContainer = styled(Stack)({
  backgroundColor: palette.grey[2400],
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 12px',
  borderTopRightRadius: BORDER_RADIUS,
  borderTopLeftRadius: BORDER_RADIUS
});

export const StartRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px'
});

export const StartRowText = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  color: palette.grey[500]
});

export const BottomContainer = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'end',
  width: '100%',
  height: '24px'
});

export const ButtonContainer = styled(Box)({
  borderRadius: '50%',
  width: '24px',
  height: '24px',
  backgroundColor: palette.black
});

export const TextInput = styled(TextareaAutosize)({
  backgroundColor: 'transparent',
  width: '100%',
  resize: 'none',
  padding: '12px 12px 0',
  fontSize: '12px',
  fontFamily: 'inherit',
  lineHeight: 1.5,
  borderRadius: '8px',
  border: 'unset',
  '&:focus': {
    outline: 'unset',
    outlineOffset: '2px'
  },
  maxHeight: '96px',
  overflowY: 'auto'
});

export const QuickActionsButton = styled('button')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  padding: '4px 8px',
  height: '28px',
  background: 'transparent',
  borderRadius: '18px',
  border: 'none',
  cursor: 'pointer',
  outline: 'none',
  boxSizing: 'border-box',
  zIndex: 1,
  '::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '18px',
    padding: '2px', // thickness of the border
    background: 'linear-gradient(90deg, #366EE9 0%, #AF83F9 36.5%, #715DE6 66.8%, #7E4CDC 100%)',
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    pointerEvents: 'none',
    zIndex: -1
  }
});

export const RemoveMeetingsButton = styled(Button)({
  background: palette.grey[800],
  color: palette.grey[500],
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: '12px',
  transition: 'background 0.2s, box-shadow 0.2s',
  gap: '4px',
  '&:hover': {
    color: palette.black
  }
});
